import { Box, Dialog, Slide, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import theme from "../../theme";
import styled from "@emotion/styled";
import { RadioOption } from "./TableTitle";
import { handleClickForSort } from "../../utils/util";

type Prop = {
  open: boolean;
  onClose: () => void;
  title?: string;
  sortList: RadioOption[];
  sort?: string;
  setSort?: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const BottomSheet = ({
  open,
  onClose,
  title,
  sortList,
  sort,
  setSort,
}: Prop) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      PaperProps={{
        sx: {
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          height: "354px",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100vw",
          backgroundColor: theme.color.white,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        {/* 바텀 시트 타이틀 영역 */}
        <Box
          sx={{
            height: "41px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "30px",
            paddingRight: "29.8px",
          }}
        >
          <Typography
            fontSize={theme.fontSize.BOTTOM_SHEET_1}
            sx={{ height: "16px" }}
          >
            {title}
          </Typography>
          <button
            onClick={onClose}
            style={{ width: "15px", height: "15px" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.48238 0.219687C1.18951 -0.0732292 0.714673 -0.0732291 0.421803 0.219687C0.128933 0.512604 0.128933 0.987516 0.421803 1.28043L6.5392 7.39881L0.219103 13.7199C-0.0737668 14.0128 -0.0737668 14.4877 0.219103 14.7807C0.511973 15.0736 0.986809 15.0736 1.27968 14.7807L7.59978 8.45955L13.9198 14.7806C14.2127 15.0735 14.6875 15.0735 14.9804 14.7806C15.2733 14.4877 15.2733 14.0128 14.9804 13.7199L8.66035 7.39881L14.7777 1.28047C15.0706 0.987554 15.0706 0.512643 14.7777 0.219726C14.4848 -0.0731906 14.01 -0.0731903 13.7171 0.219726L7.59978 6.33806L1.48238 0.219687Z"
                fill={theme.color.neutral_500}
              />
            </svg>
          </button>
        </Box>

        {/* 상세 항목 영역 */}
        <Box
          sx={{
            overflowY: "scroll",
            maxHeight: `calc(354px - 41px)`,
            "::-webkit-scrollbar": {
              display: "block",
              width: "7px",
            },
            "::-webkit-scrollbar-thumb": {
              backgroundColor: theme.color.white,
              border: `1px solid #E5E5E8`,
              borderRadius: "0px",
            },
            "::-webkit-scrollbar-track ": {
              backgroundColor: "#E5E5E8",
              borderRadius: "0px",
            },
          }}
        >
          {sortList.map((el) => (
            <div
              key={el.label + el.value}
              onClick={() => {
                if (setSort && !el.value) {
                  setSort("");
                  onClose();
                  return;
                }
                handleClickForSort(el.value, setSort);
                onClose();
              }}
            >
              <Box
                sx={{
                  height: "51px",
                  backgroundColor:
                    el.value === sort?.slice(0, sort.indexOf(" "))
                      ? theme.color.green_100
                      : `none`,
                  paddingLeft: "30px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="7.33333"
                    fill="white"
                    stroke={
                      el.value === sort?.slice(0, sort.indexOf(" "))
                        ? theme.color.green_500
                        : theme.color.neutral_200
                    }
                    strokeWidth="5.33333"
                  />
                </svg>
                <input type="radio" style={{ display: "none" }} />
                <RadioLabel>{el.label}</RadioLabel>
              </Box>
            </div>
          ))}
        </Box>
      </Box>
    </Dialog>
  );
};

const RadioLabel = styled.label`
  font-size: ${theme.fontSize.BOTTOM_SHEET_1};
  font-weight: ${theme.fontWeight.BOLD};
`;
